import { IWildlifeRefugeAdvisoryProperties } from '@autopylot-internal/tiles-client';
import { SecondaryWarningAdvisory } from '../SecondaryAdvisory';
import { AdvisoryBlockIcon } from '../../components/icons/Icons';
import { ICompositeAdvisoryProperties } from './ICompositeAdvisoryProperties';
import { AdvisoryLink } from './AdvisoryLink';

export const WildlifeRefugeAdvisory = (props: ICompositeAdvisoryProperties<IWildlifeRefugeAdvisoryProperties>) => {
    const distinctNames = Array.from(new Set(props.advisories.map(a => a.ORGNAME)));
    return (
        <SecondaryWarningAdvisory header="Wildlife Refuge" advisoryType={props.advisoryType} GLOBAL_ID={props.advisories[0].GLOBAL_ID} icon={AdvisoryBlockIcon} iconColor='danger'>
            <>
                <p>
                    Launching, landing, or disturbing wildlife within Wildlife Refuges is prohibited.
                    Your mission overlaps <strong>{distinctNames.join(', ')}</strong>. Violations are punishable
                    by harsh fines and penalties.
                </p>
                <p>
                    <AdvisoryLink
                        text="FWS Drone Law"
                        url="https://www.fws.gov/law/drones-unmanned-aircraft"
                    />
                </p>
            </>
        </SecondaryWarningAdvisory>
    );
};
